// src/components/cursor-light.js
import React, { useEffect } from 'react';
import styled from 'styled-components';

const StyledCursorGlow = styled.div`
  pointer-events: none;
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2;

  /* Stronger, visible purple glow */
  background-image:
    /* inner soft pink core */
    radial-gradient(
      180px circle at var(--cursor-x, -200px) var(--cursor-y, -200px),
      rgba(250, 206, 224, 0.85),
      rgba(250, 206, 224, 0) 70%
    ),
    /* outer #39395f haze */
    radial-gradient(
      420px circle at var(--cursor-x, -200px) var(--cursor-y, -200px),
      rgba(57, 57, 95, 0.65),
      rgba(57, 57, 95, 0) 90%
    );

  mix-blend-mode: soft-light; /* more visible on light peach background */
  opacity: 0.9;
  transition: opacity 0.25s ease-out;
`;

const CursorLight = () => {
  useEffect(() => {
    const handleMove = e => {
      const r = document.documentElement;
      r.style.setProperty('--cursor-x', `${e.clientX}px`);
      r.style.setProperty('--cursor-y', `${e.clientY}px`);
    };

    window.addEventListener('pointermove', handleMove);
    return () => window.removeEventListener('pointermove', handleMove);
  }, []);

  return <StyledCursorGlow />;
};

export default CursorLight;
